var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmilyRadial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 861,
    height: 861,
    viewBox: "0 0 861 861",
    className: "radial-image",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.107 430.254C507.107 388.094 473.197 353.855 431.164 353.322L430.17 353.316C387.679 353.316 353.232 387.763 353.232 430.254L353.238 431.248C353.766 472.95 387.473 506.657 429.176 507.185L430.17 507.191C472.329 507.191 506.568 473.281 507.101 431.248L507.107 430.254ZM572.348 430.254C572.348 508.777 508.693 572.432 430.17 572.432C351.647 572.432 287.992 508.777 287.992 430.254C287.992 351.731 351.647 288.076 430.17 288.076C508.693 288.076 572.348 351.731 572.348 430.254Z",
    fill: "url(#paint0_radial_20917_34250)",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M587.651 430.255C587.651 343.284 517.148 272.78 430.177 272.78C343.206 272.78 272.702 343.284 272.702 430.255C272.702 517.226 343.206 587.729 430.177 587.729C517.148 587.729 587.651 517.226 587.651 430.255ZM667.542 430.255C667.542 561.348 561.27 667.62 430.177 667.62C299.084 667.62 192.812 561.348 192.812 430.255C192.813 299.162 299.084 192.891 430.177 192.891C561.269 192.891 667.542 299.162 667.542 430.255Z",
    fill: "url(#paint1_radial_20917_34250)",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M682.9 430.254C682.9 290.676 569.75 177.526 430.172 177.526C290.594 177.527 177.445 290.676 177.444 430.254C177.444 569.287 289.712 682.098 428.538 682.977L430.172 682.982C569.204 682.982 682.015 570.714 682.895 431.889L682.9 430.254ZM762.79 430.254C762.79 613.954 613.872 762.872 430.172 762.872C246.472 762.872 97.5547 613.953 97.5547 430.254C97.5549 246.555 246.473 97.6369 430.172 97.6367C613.871 97.6367 762.79 246.554 762.79 430.254Z",
    fill: "url(#paint2_radial_20917_34250)",
    fillOpacity: 0.03
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M780.684 430.341C780.683 236.852 623.829 79.999 430.341 79.999C236.852 79.9993 79.9993 236.852 79.999 430.341C79.999 623.074 235.629 779.458 428.075 780.677L430.341 780.684C623.074 780.684 779.458 625.053 780.677 432.607L780.684 430.341ZM860.573 430.341C860.573 667.951 667.951 860.573 430.341 860.573C192.73 860.573 0.109375 667.951 0.109375 430.341C0.109623 192.731 192.731 0.109622 430.341 0.109375C667.951 0.109375 860.573 192.73 860.573 430.341Z",
    fill: "url(#paint3_radial_20917_34250)",
    fillOpacity: 0.02
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20917_34250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(434.015 432.544) rotate(-0.238217) scale(550.904 497.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6AC55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283654,
    stopColor: "#F73B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444098,
    stopColor: "#D348E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635907,
    stopColor: "#47A3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F0FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20917_34250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.048 434.943) rotate(-0.574037) scale(467.937 422.906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6AC55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283654,
    stopColor: "#F73B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444098,
    stopColor: "#D348E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635907,
    stopColor: "#47A3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F0FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_20917_34250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(442.804 437.778) rotate(-90) scale(526.097 475.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6AC55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258126,
    stopColor: "#F73B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425535,
    stopColor: "#D348E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567367,
    stopColor: "#47A3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F0FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_20917_34250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(447.852 440.771) rotate(-2.75616) scale(569.661 514.842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6AC55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283654,
    stopColor: "#F73B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444098,
    stopColor: "#D348E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635907,
    stopColor: "#47A3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F0FE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmilyRadial);
export default __webpack_public_path__ + "static/media/emily-radial.a8b5bd04.svg";
export { ForwardRef as ReactComponent };